module.exports = __webpack_public_path__ + "img/b18-5.158acdf1.jpg";